import { render, staticRenderFns } from "./ActualityFilters.vue?vue&type=template&id=a4fddd9a&scoped=true&"
import script from "./ActualityFilters.vue?vue&type=script&lang=js&"
export * from "./ActualityFilters.vue?vue&type=script&lang=js&"
import style0 from "./ActualityFilters.vue?vue&type=style&index=0&id=a4fddd9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fddd9a",
  null
  
)

export default component.exports